import PropTypes from "prop-types";
import React, { useState } from "react";
import { Search } from "@mui/icons-material/index";
import { TextField, InputAdornment } from "@mui/material";
import Autosuggest from "../Autosuggest/Autosuggest";
import { useField } from "formik";

const renderInputComponent = (setAnchorEl, disabled, error) => ({
  inputRef = () => {},
  ref,
  ...other
}) => {
  return (
    <TextField
      disabled={disabled}
      fullWidth
      variant="filled"
      InputProps={{
        ref: node => setAnchorEl(node),
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        endAdornment: (
          <InputAdornment>
            <Search color={error ? "error" : "action"} />
          </InputAdornment>
        )
      }}
      {...other}
    />
  );
};

const AutosuggestField = ({
  renderSuggestionText,
  suggestions,
  disabled,
  placeholder,
  defaultValue,
  onChange,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const [, meta, helpers] = useField(props);
  let error = meta.touched && meta.error;
  error = typeof error === "string" ? error : "";
  const handleChange = value => {
    helpers.setValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Autosuggest
      renderInputComponent={renderInputComponent(setAnchorEl, disabled, error)}
      anchorEl={anchorEl}
      renderSuggestionText={renderSuggestionText}
      suggestions={suggestions}
      onTextInputChange={handleChange}
      inputProps={{
        error: !!error,
        helperText: error,
        label: placeholder
      }}
      defaultValue={defaultValue}
    />
  );
};

export default AutosuggestField;

AutosuggestField.propTypes = {
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  renderSuggestionText: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};
